<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          کاربران
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="1"
                 v-if="can('newUser')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <div v-if="showDialog">
              <create-user :model="model" :is-edit="isEdit" :role-items="roleItems" :user-type-items="userTypeItems"
                           :building-list="buildingList" :dialogStatus.sync="showDialog"/>
            </div>
            <div v-if="showDialogExcel">
              <page-excel-uplode :building-list="buildingList" :dialogStatus.sync="showDialogExcel"/>
            </div>

          </v-col>
          <v-col cols="12"
                 sm="3"
                 md="3"

          >
            <v-autocomplete
                :items="userTypeItems"
                v-model="type"
                placeholder="نوع کاربر"
                dense
                outlined
                auto-select-first append-icon="mdi-menu-down"

            />


          </v-col>
          <v-col cols="12"
                 sm="3"
                 md="3"
                 class="d-inline-flex"
          >
            <v-text-field
                clearable
                @click:clear="clearable"
                outlined
                dense
                placeholder="نام شخص یا شماره موبایل"
                v-model="searchvalue"
            />
            <v-btn fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="3"
                 md="3"
                 class="d-inline-flex"
          >

            <v-btn depressed class="mr-1"  small color="success" @click="showDialogExcel=true">
              بارگزاری فایل اکسل
            </v-btn>


          </v-col>
          <v-col cols="12"
                 sm="3"
                 md="3"
                 v-if="can('listWhitOutBuilding')"

          >
            <v-switch dense class="mt-0 pt-0" :label="changeTable?' کاربران با مجتمع':' کاربران بدون مجتمع'"
                      v-model="changeTable" @change="search"/>



          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="5" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>
        </v-row>
        <v-spacer/>
        <b-table
            v-if="can('userList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped

        >
          <template #cell(actions)="row">
            <v-btn depressed class="mr-1" v-if="can('editUser')" small color="primary" @click="forEdit(row.item)">
              ویرایش
            </v-btn>
            <!--            <v-btn depressed class="mr-1" v-if="can('deleteUser')" small color="error" @click="remove(row.item)">-->
            <!--              حذف-->
            <!--            </v-btn>-->
          </template>
<!--          <template #cell(active)="row">-->
<!--            <v-switch dense class="mt-0 pt-0" :label="row.item.active?'فعال':'غیرفعال'" v-model="row.item.active"-->
<!--                      @change="changeStatus(row.item)"/>-->
<!--          </template>-->

        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateUser from './PageEdit'
import PageExcelUplode from './PageExcelUplode.vue'
import User_se from "./User_se";
import {mapMutations} from "vuex";

export default {
  name: 'User',
  components: {
    CreateUser,
    PageExcelUplode
  },
  data() {
    return {
      modelId: '',
      searchvalue: '',
      type: '',
      model: {},
      showDialog: false,
      showDialogExcel: false,
      isEdit: false,
      changeTable: true,
      modelAtributes: {},
      dataItems: [],
      roleItems: [],
      buildingList: [],
      userTypeItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'personName', label: 'نام واحد', sortable: true, sortDirection: 'desc'},
        {key: 'mobile', label: 'شماره موبایل', sortable: true, sortDirection: 'desc'},
        {key: 'roleName', label: 'نقش', sortable: true, sortDirection: 'desc'},
        {key: 'buildingName', label: 'مجتمع ها ', sortable: true, sortDirection: 'desc'},
        // {key: 'active', label: 'وضعیت کاربر', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('User', () => {
      this.fillDataItems()
    })

  },

  methods: {
    close() {
      this.searchvalue = ""
      this.paging = {}
      this.$root.$emit('User')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    fetch() {
      User_se.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.roleItems = response.data.roleItems
        this.buildingList = response.data.buildingList
        this.userTypeItems = response.data.userTypeItems

      })
      this.showDialog = true;
    },

    listWhitOutBuilding () {
      User_se.listWhitOutBuilding(this.skip - 1, this.take, this.type, this.searchvalue).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.userList
        this.userTypeItems = response.data.userTypeItems
      })
    },
    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.isEdit = false;
      this.fetch()
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.isEdit = true;
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              User_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      if (this.changeTable) {
        this.fillDataItems()
      } else {
        this.listWhitOutBuilding()
      }

    },
    changeStatus(model) {
      User_se.changeStatus(model).then(() => {
        this.fillDataItems()
      })
    },
    search() {
      if (this.changeTable) {
        this.fillDataItems()
      } else {
        this.listWhitOutBuilding()
      }

    },
    fillDataItems() {
      User_se.getPage(this.skip - 1, this.take, this.type, this.searchvalue).then(response => {
        this.paging = response.data.page
        this.dataItems = response.data.userList
        this.userTypeItems = response.data.userTypeItems
        this.buildingList = response.data.buildingList
      });
    },
    clearable() {
      this.searchvalue = ''
      this.fillDataItems()
    },



  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
